export const Action = {
  ADD: "add",
  BLUR: "blur",
  BLUR_SPLITTER: "blur-splitter",
  DRAG_START: "drag-start",
  DRAG_STARTED: "drag-started",
  DRAG_DROP: "drag-drop",
  FOCUS: "focus",
  FOCUS_SPLITTER: "focus-splitter",
  INITIALIZE: "initialize",
  LAYOUT_RESIZE: "layout-resize",
  MAXIMIZE: "maximize",
  MINIMIZE: "minimize",
  REMOVE: "remove",
  REPLACE: "replace",
  RESTORE: "restore",
  SAVE: "save",
  SPLITTER_RESIZE: "splitter-resize",
};
